<template>
<el-row :style="coverStyle" class="search-structure-cover">
  <div style="height:50px" class="hidden-xs-only">
    &nbsp;
  </div>
  <el-col :xs="{span:24}" :sm="{span:22,offset:1}" :md="{span:18,offset:3}" :lg="{span:14,offset:5}" class="cover-content">
    <div class="cover-head">
      <div>{{stepTitles[step]}}</div>
      <div class="close-button" @click="hidden"><i class="el-icon-close"></i></div>
    </div>

    <div class="submit-panel">
      <template v-if="steps[step]==='set-structure'">
        <el-row class="set-structure">
          <el-col :sm="{span:24}" :md="{span:12}">
            <div class="search-structure">
              <div class="search-structure-label">
                Please input protein name or PDB ID
              </div>
              <el-input class="search-input" v-model="query" @keyup.enter.native="search(query)" size="large" placeholder="Name / PDB ID" clearable>
                <div class="search-input-button" @click="search(query)" slot="append">Search</div>
              </el-input>
              <div class="search-examples">
                <div class="search-example" v-for="(example,i) in ['CheY', '1A0O', 'Caspase', 'PTP', 'NBD1', 'FBPase']" @click="search(example)" :key="i">
                  {{ example }}
                </div>
              </div>
            </div>
          </el-col>

          <el-col :sm="{span:24}" :md="{span:12}">
            <div class="upload-structure">
              <div class="upload-structure-label"> or upload the structure (.pdb) </div>
              <input class="upload-file" type="file" @change="uploadStructure($event)">
            </div>
          </el-col>
        </el-row>

        <el-row class="search-result-row" v-for="(match, i) in queryResult" @click.native="selectStructure(match.rcsb_id)" :key="i">
          <el-col :span="8">
            <img style="object-fit:cover;width:250px" :src="`https://cdn.rcsb.org/images/structures/${match.rcsb_id.substr(1,2)}/${match.rcsb_id}/${match.rcsb_id}_assembly-1.jpeg`.toLowerCase()">
          </el-col>

          <el-col :span="16" style="padding-top:20px">
            <el-row style="margin:20px 0px">
              <el-col :span="24">{{match.struct.pdbx_descriptor}}</el-col>
            </el-row>

            <el-row style="margin:20px 0px">
              <el-col :span="6"><b>PDB ID</b>:</el-col>
              <el-col :span="16">{{match.rcsb_id}}</el-col>
            </el-row>

            <el-row style="margin:20px 0px">
              <el-col :span="6"><b>Description</b>:</el-col>
              <el-col :span="16">{{match.struct.title}}</el-col>
            </el-row>

          </el-col>
        </el-row>
      </template>

      <div class="search-structure-wait" v-if="steps[step]==='set-structure'&&searchingStructure">
        <i class="el-icon-loading"></i>
      </div>

      <div v-if="steps[step]==='set-sites'&&nglCreated" class="set-sites">
        <template v-if="taskTypes[taskType] === 'predict-allosteric-sites'">
          <div class="set-sites-label">
            Please designate the active site.
            <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">
              Please refer to the <a target="_blank" :href="$store.state.host+'/ohm/#/help'">Help</a> page for how to designate the active site.
            </div>
            <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div class="set-sites-input">
            <div class="set-site" style="margin: 5px 0px">
              Residues <el-input class="site-chain-input" v-model="activeSite" size="medium" disabled></el-input> (<span class="sequence-button" @click="toggleActive">{{ activeVisible ? 'hide' : 'edit' }}</span>)
            </div>

            <div class="sequence" style="margin: 5px 0px">
              <sequence v-if="activeVisible" :structure="store.objects[1]" :selection="activeObject" @toggle="$refs.ngl.toggleSelection($event)"></sequence>
            </div>
          </div>
        </template>

        <template v-if="taskTypes[taskType] === 'identify-allosteric-pathways'">
          <div class="set-sites-label">
            Please designate the active site and the allosteric site.
            <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">
              Please refer to the <a target="_blank" :href="$store.state.host+'/ohm/#/help'">Help</a> page for how to designate the active site and the allosteric site.
            </div>
            <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <el-row type="flex" align="middle" style="margin: 5px 0px">
            <el-col :span="4">
              Active Site
            </el-col>

            <el-col :span="15">
              <el-input class="site-chain-input" v-model="activeSite" size="medium" disabled></el-input> (<span class="sequence-button" @click="toggleActive">{{ activeVisible ? 'hide' : 'edit' }}</span>)
            </el-col>
          </el-row>

          <el-row type="flex" align="middle" style="margin: 5px 0px">
            <el-col :offset="4" :span="20">
              <sequence v-if="activeVisible" :structure="store.objects[1]" :selection="activeObject" @toggle="$refs.ngl.toggleSelection($event)"></sequence>
            </el-col>
          </el-row>

          <el-row type="flex" align="middle" style="margin: 5px 0px">
            <el-col :span="4">
              Allosteric Site
            </el-col>

            <el-col :span="15">
              <el-input class="site-chain-input" v-model="allostericSite" size="medium" disabled></el-input> (<span class="sequence-button" @click="toggleAllosteric">{{ allostericVisible ? 'hide' : 'edit' }}</span>)
            </el-col>
          </el-row>

          <el-row type="flex" align="middle" style="margin: 5px 0px">
            <el-col :offset="4" :span="20">
              <sequence v-if="allostericVisible" :structure="store.objects[1]" :selection="allostericObject" @toggle="$refs.ngl.toggleSelection($event)"></sequence>
            </el-col>
          </el-row>

        </template>
      </div>

      <el-row>
        <el-col :offset=1 :span="22">
          <ngl-view :id="nglId" :style="viewportStyle" ref="ngl" :height="400" :nameWidth="200" @toggle:selection="onToggleSelection" @init="nglCreated=true"></ngl-view>
        </el-col>
      </el-row>

      <div class="set-parameters" v-if="steps[step]==='set-parameters'">
        <el-row class="parameter-row">
          <el-col :xs="{span:24}" :sm="{span:10}" class="vcenter">
            <div><b>Task Title</b></div>
          </el-col>
          <el-col :xs="{span:18}" :sm="{span:10}" class="vcenter">
            <el-input v-model="taskTitle"></el-input>
          </el-col>
        </el-row>

        <el-row class="parameter-row">
          <el-col :xs="{span:24}" :sm="{span:10}" class="vcenter">
            <div>
              <b>Distance cutoff of contacts</b>
              <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                This distance cutoff decides how far away are two atoms to be counted as a contact.
              </div>
              <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :xs="{span:18}" :sm="{span:10}" class="vcenter">
            <el-input v-model="contactCutoff"></el-input>
          </el-col>
          <el-col :span="1" class="vcenter">
            <div>&nbsp;&#8491;</div>
          </el-col>
        </el-row>

        <el-row class="parameter-row" v-if="taskType!==3">
          <el-col :xs="{span:24}" :sm="{span:10}" class="vcenter">
            <div>
              <b>Active Site</b>
            </div>
          </el-col>
          <el-col :xs="{span:18}" :sm="{span:10}" class="vcenter">
            <el-input v-model="activeSite" disabled></el-input>
          </el-col>
        </el-row>

        <el-row class="parameter-row" v-if="taskType==1">
          <el-col :xs="{span:24}" :sm="{span:10}" class="vcenter">
            <div>
              <b>Allosteric Site</b>
            </div>
          </el-col>
          <el-col :xs="{span:18}" :sm="{span:10}" class="vcenter">
            <el-input v-model="allostericSite" disabled></el-input>
          </el-col>
        </el-row>

        <el-row class="parameter-row">
          <el-col :xs="{span:24}" :sm="{span:10}" class="vcenter">
            <div>
              <b>alpha</b>
              <el-tooltip class="item" effect="dark" placement="bottom">
              <div slot="content">
                Please refer to our manuscript for the meaning of alpha.
              </div>
              <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :xs="{span:18}" :sm="{span:10}" class="vcenter">
            <el-input v-model="alpha"></el-input>
          </el-col>
        </el-row>

        <el-row class="parameter-row" v-if="taskTypes[taskType] !== 'predict-allosteric-pairs'">
          <el-col :xs="{span:24}" :sm="{span:10}" class="vcenter">
            <div><b># rounds of perturbation propagation</b></div>
          </el-col>
          <el-col :xs="{span:18}" :sm="{span:10}" class="vcenter">
            <el-input v-model="diffuseSteps"></el-input>
          </el-col>
        </el-row>
      </div> <!-- set parameters -->
    </div>

    <div class="buttons">
      <el-button class="button-prev" type="primary" v-if="steps[step]!=='set-structure'" @click="step-=1">Prev</el-button>
      <el-button class="button-next" type="primary" v-if="steps[step]!=='set-parameters'&&steps[step]!=='set-structure'" @click="step+=1">Next</el-button>
      <el-button class="button-submit" type="primary" v-if="steps[step]==='set-parameters'" @click="submit">Submit</el-button>
    </div>

  </el-col>
</el-row>
</template>

<script>
import axios from 'axios'
import Sequence from './Sequence.vue'
import NglView from './NglView/NglView.vue'
import * as NGL from 'ngl'
// import { Vector3, Matrix4 } from 'three'

export default {
  name: 'Submit',

  data () {
    return {
      nglId: `${Math.floor(Math.random() * 1000000)}`,

      step: 0,
      steps: ['set-structure', 'set-sites', 'set-parameters'],

      stepTitles: ['SET STRUCTURE', 'SET SITES', 'SET PARAMETERS'],

      searchingStructure: false,

      taskType: 0,
      taskTypes: ['predict-allosteric-sites', 'identify-allosteric-pathways', 'perturb-allosteric-pathways', 'predict-allosteric-pairs'],
      taskTypeTitles: ['Predict allosteric sites', 'Identify allosteric pathways', 'Perturb allosteric pathways', 'Predict allosteric pairs'],

      query: '',
      queryResult: [],

      reprs: {}, // Representations
      representationVisibilities: {}, // Representation Visibilities

      pickedResidue: '',
      pickingMenuStyle: {
        display: 'none',
        position: 'fixed',
        zIndex: 99,
//        pointerEvents: 'none',
//        backgroundColor: 'rgba( 1, 1, 1, 0.6 )',
        backgroundColor: 'white',
//        color: 'lightgrey',
        padding: '0px',
        fontFamily: 'sans-serif'
      },

      taskTitle: '',
      site1Chain: 'A',
      site2Chain: 'A',
      site1Residue: 5,
      site2Residue: 25,
      contactCutoff: 3.4,
      alpha: 3.0,
      diffuseSteps: 10000,

      activeVisible: false,
      allostericVisible: false,

      nglCreated: false
    }
  },

  components: {
    Sequence, NglView
  },

  computed: {
    store () {
      let v = this
      return v.$store.getters['ngl/instance'](v.nglId)
    },

    activeSite () {
      return this.getSite('active-site')
    },

    allostericSite () {
      return this.getSite('allosteric-site')
    },

    coverStyle () {
      return this.value ? {
        left: 0, right: 0, top: 0, bottom: 0
      } : {
        right: '300%'
      }
    },

    viewportStyle () {
      let style = {
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
      }

      if (this.steps[this.step] === 'set-sites') {
        style.margin = '20px auto'
      } else {
        style.position = 'fixed'
        style.right = '300%'
      }

      return style
    },

    activeObject () {
      return this.store.getObjectByName('active-site')
    },

    allostericObject () {
      return this.store.getObjectByName('allosteric-site')
    }
  },

  props: [ 'value' ],

//  watch: {
//    value (nV, oV) {
//      if (this.value) {
//        document.body.style.overflowY = 'hidden'
//      } else {
//        document.body.style.overflowY = 'auto'
//      }
//    }
//  },

  methods: {
    onToggleSelection () {
      this.activeVisible = this.activeObject.visible
      this.allostericVisible = this.allostericObject.visible
    },

    toggleActive () {
      if (this.activeVisible) {
        this.activeVisible = false
        this.activeObject.hide()
      } else {
        this.activeVisible = true
        this.activeObject.show()

        if (this.allostericVisible) {
          this.allostericVisible = false
        }
      }
    },

    toggleAllosteric () {
      if (this.allostericVisible) {
        this.allostericVisible = false
        this.allostericObject.hide()
      } else {
        this.allostericVisible = true
        this.allostericObject.show()

        if (this.activeVisible) {
          this.activeVisible = false
        }
      }
    },

    getSite (selectionName) {
      let residues = []

      let selectionObject = this.store.getObjectByName(selectionName)
      let structureObject = this.store.objects[1]

      if (selectionObject && structureObject) {
        for (let i = 0; i < structureObject.residues.length; i++) {
          for (let j = 0; j < structureObject.residues[i].length; j++) {
            let res = structureObject.residues[i][j]
            if (selectionObject.selections[0].residueTest(res)) {
//              if (res.active) {
              residues.push(`${res.chainname}/${res.resno}`)
//              }
            }
          }
        }
//        console.log('get site')
//        console.log(selectionObject)
//        console.log(structureObject)
      }

      return residues.join(',')
    },

    debug (e) {
//      console.log(e)
    },

    residueSelection (chainname, resno) {
      return `${resno}:${chainname}.CA`
    },

    predictSites () {
      let v = this

//      console.log('predict-sites')

      v.show()

      v.step = 0
      v.taskType = 0
    },

    identifyPathways () {
      let v = this

      v.show()

      v.step = 0
      v.taskType = 1
    },

    perturbPathways () {
      let v = this

      v.show()

      v.step = 0
      v.taskType = 2
    },

    predictCorrelations () {
      let v = this

      v.show()

      v.step = 0
      v.taskType = 3
    },

    search (query) {
      let v = this

      v.show()

      v.step = 0

      v.searchingStructure = true
      v.query = query
      v.queryResult = ''

      axios({
        method: 'get',
        url: v.$store.state.host + '/dokhlab/actions/search_rcsb?query=' + encodeURIComponent(query),
        withCredentials: true
      }).then(response => {
        v.queryResult = response.data.data.entries
        v.searchingStructure = false
      }).catch(() => {
        v.searchingStructure = false
        alert('Search Failed!')
      })
    },

    show () {
      this.$emit('input', true)
    },

    hidden () {
      this.$emit('input', false)
    },

    post (url, p, cb1 = () => {}, cb2 = () => {}) {
      let parts = [new Blob([JSON.stringify(p)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'front-config.json', {
        type: 'application/json'
      })

      let formData = new FormData()

      formData.append('par', fileToSend)

      axios({
        method: 'post',
        url,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
        cb1(response)
      }).catch(error => {
        cb2(error)
      })
    },

    submit () {
      let v = this
      let pdbWriter = new NGL.PdbWriter(v.store.objects[1].components[0].structure)
      let p = {
        task_type: v.taskType,
        title: v.taskTitle,
        active_site: v.activeSite,
        allosteric_site: v.allostericSite,
        contact_cutoff: v.contactCutoff,
        alpha: parseFloat(v.alpha) / 10.0 + 0.05,
        diffuse_steps: v.diffuseSteps,
        structure_type: 'pdb',
        structure_data: pdbWriter.getData()
      }

      if (p.active_site === '' && this.taskType !== 3) {
        alert('The active site is empty!')
        return
      }

      if (p.allosteric_site === '' && this.taskType !== 0 && this.taskType !== 3) {
        alert('The allosteric site is empty!')
        return
      }

      let url = v.$store.state.host + `/dokhlab/actions/ohm/submit`
      v.post(url, p, response => {
        alert('Submitted Successfully!')
        v.hidden()
        window.location.href = '#/Queue'
      }, error => {
        console.log(error)
        alert('Submission failed!')
      })
    },

    selectStructure (id) {
      let v = this

      v.step = 1

      v.taskTitle = id

      v.store.deleteObjectByName('all')
      v.$refs.ngl.load(`rcsb://${id}`, { firstModelOnly: true }).then(function (obj) {
        v.store.addObject('active-site', 'selection', [obj.components[0]], [new NGL.Selection('1')])
        v.store.addObject('allosteric-site', 'selection', [obj.components[0]], [new NGL.Selection('2')])
      })
    },

    uploadStructure (e) {
      let v = this

      v.step = 1

      let f = e.target.files[0]
      v.taskTitle = f.name.replace(/\.[^/.]+$/, '')

      v.store.deleteObjectByName('all')
      v.$refs.ngl.load(f, { firstModelOnly: true }).then(function (obj) {
//        console.log(v)
        obj.setColor('bfactor')
        v.store.addObject('active-site', 'selection', [obj.components[0]], [new NGL.Selection('1')])
        v.store.addObject('allosteric-site', 'selection', [obj.components[0]], [new NGL.Selection('2')])
      })
    }
  },

  mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.search-structure-cover {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.cover-content {
  /*
  width: 1000px;
  margin: 50px auto;
  background-color: white;
  */
  position: relative;
  background-color: #dadada;
}

.cover-head {
  position: relative;
  font-size: 16px;
  padding: 10px;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.view-structure-background {
  background-color: #dadada;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

/*
#viewport {
  width: 680px;
  height: 450px;
  box-shadow: 0 0 5px #888888;
}
*/

.buttons {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button-next {
  margin: 15px 30px 15px auto;
}

.button-prev {
  margin: 15px auto 15px 20px;
}

.button-submit {
  margin: 15px 30px 15px auto;
}

.close-button {
  margin-left: auto;
  margin-right: 0;
  z-index: 99;
  cursor: pointer;
  font-size: 20px;
  opacity: 0.5;
}

.close-button:hover {
  opacity: 1;
}

.set-structure {
  background-color: $theme-color;
  color: white;
  font-size: 16px;
}

.search-structure {
  margin: 20px 30px;
}

.search-structure-label {
  margin-bottom: 15px;
}

.upload-structure {
  margin: 20px 30px;
}

.upload-structure-label {
  margin-bottom: 15px;
}

.upload-file {
  width: 100%;
  box-sizing: border-box;
  line-height: 1.5;
  padding: 8px;
  font-size: 16px;
  border: 0;
  border-radius: 4px;
  color: $font-grey;
}

.search-input-button {
  cursor: pointer;
  color: black;
  font-size: 16px;
}

.submit-area-background {
  background-color: white;
  width: 100%;
}

.submit-area {
  width: 700px;
  margin: 0px auto;
  padding: 10px;
}

.el-button--primary {
  background-color: $theme-color;
  border-color: $theme-color;
}

.el-button--primary:hover {
  opacity: 0.5;
}

.submit-panel {
  font-size: 16px;
  color: $font-grey;
  max-height: 700px;
  overflow-x: hidden;
  overflow-y: scroll;
}

.search-result-head {
  display: flex;
  flex-direction: row;
  weight: 100%;
  padding: 10px;
  font-weight: 600;
}

.search-result-row {
  background-color: white;
  box-sizing: border-box;
  padding: 0;
  cursor: pointer;
  margin: 20px 30px 20px 30px;
}

.search-result-row:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.search-result-row-left {
  float: left;
  width: 200px;
}

.search-result-row-right {
  float: left;
  width: 600px;
  margin: 20px;
}

.search-result-pref-name {
  font-weight: 800;
}

.search-result-compound-name {
  width: 100%;
  margin-bottom: 15px;
}

.search-result-synonyms {
  width: 100%;
}

.search-result-formula {
  width: 100%;
}

.search-result-weight {
  width: 100%;
}
.search-result-smiles {
  width: 100%;
}

.search-structure-wait {
  font-size: 100px;
  height: 200px;
  vertical-align: middle;
  text-align: center;
  color: $font-grey;
}

.task-type-row {
  text-align: center;
  background-color: white;
  box-sizing: border-box;
  padding: 0;
  cursor: pointer;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
}

.task-type-row:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.picking-menu {
  padding: 0px;
  font-size: 12px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.picking-menu-item {
  padding: 8px;
  margin: 0px;
}

.picking-menu-item.picking-menu-item-button {
  background-color: white;
  font-weight: normal;
  cursor: pointer;
}

.picking-menu-item.picking-menu-item-button:hover {
  background-color: #67c23a;
  font-weight: bold;
  color: white;
}

.search-examples {
  display: flex;
  flex-direction: row;
}

.search-example {
  margin-right: 20px;
  cursor: pointer;
}

.set-sites {
  background-color: $theme-color;
  color: white;
  padding: 20px 50px;
}

.set-sites-label {
  margin-bottom: 10px;
}

.set-sites-input {
  padding-left: 30px;
}

.set-site {
  margin-bottom: 10px;
}

.site-chain-input {
  width: 200px;
}

.site-residue-input {
  width: 100px;
}

.sequence {
  margin-bottom: 10px;
}

.sequence-button {
  cursor: pointer;
}

.sequence-button:hover {
  text-decoration: underline;
}

.set-parameters {
  background-color: $theme-color;
  padding: 20px 50px;
  color: white;
}

.vcenter {
  height: 55px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

</style>

